import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import QACategoryEntity from "../../../../domain/entities/qa_category.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const updateCategoryApiImpl = async (category: QACategoryEntity): Promise<Either<ErrorEntity, QACategoryEntity>> => {
    try {
        const relativeUrl = `/category/${category.id}`;
        const body = {
            "agent_id": category.agentId,
            "group": category.title,
            "description": category.description,
        };
        const response = await di.get<HostApi>(HostApiName).put(relativeUrl, body, { contentType: 'application/json' });
        if (response.updated) {
            return right(category);
        }
        return left({});
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default updateCategoryApiImpl;